import React from 'react';
import './Loader.css'; // ✅ Caminho correto para o CSS

const Loader = () => {
  return <span className="loader"></span>;
};

export default Loader;
